export default __webpack_public_path__ + "static/media/notifications.ac8af63f.png";